var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.isNotLoggedIn)?_c('v-alert',{attrs:{"type":"info"}},[_c('a',{staticStyle:{"color":"white"},attrs:{"href":"/login?redirect=%2Fereader"}},[_vm._v("Log in")]),_vm._v(" to CFMA to get your most recent eBook purchases.")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }